import { render } from "./TweetKOL.vue?vue&type=template&id=133c8aee&scoped=true"
import script from "./TweetKOL.vue?vue&type=script&lang=js"
export * from "./TweetKOL.vue?vue&type=script&lang=js"

import "./TweetKOL.vue?vue&type=style&index=0&id=133c8aee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133c8aee"]])

export default __exports__